import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import Letterbox from "./Letterbox";
import ScrubTimeline from "./ScrubTimeline";
import CustomCursor from "./CustomCursor";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";

export default function Layout({ children }) {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="grain min-h-screen bg-[var(--bg)] text-white">
      <Letterbox />
      <ScrubTimeline />
      <CustomCursor />
      <main>{children}</main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
